import React from 'react';
import AdminSidebar from './AdminSidebar';
import AdminTopBar from './AdminTopbar';
import { Outlet } from 'react-router-dom';

function AdminDashboard() {
  return (
    <>
      <AdminTopBar />
      <div className="Dashboard">
        <AdminSidebar />
        <div className="AdminDashboard">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;